import { useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import './Style.css';

const AlertMessage = ({ message, variant = 'success', show, onClose }: any) => {
  useEffect(() => {
    if (show) {
      setTimeout(() => {
        onClose();
      }, 5000); 
    }
  }, [show, onClose]);

  return (
    <Alert className="alert-message" show={show} variant={variant} onClose={onClose} dismissible>
      {message}
    </Alert>
  );
};

export default AlertMessage;
